document.addEventListener("alpine:init", () => {
  Alpine.data("companySlider", () => ({
    swiper: null,
    state: null,

    autoScrollSliderPadding: 40,
    scrollbarWidth: 0,
    innerHeight: window.innerHeight, // Get innerHeight only once to avoid problems with toolbars appearing based on scroll direction

    init() {
      this.$nextTick(() => {
        this.scrollbarWidth = this.getScrollbarWidth();
        this.checkAndUpdateSliderType();
      });

      window.addEventListener(
        "resize",
        () => {
          this.scrollbarWidth = this.getScrollbarWidth();
          this.checkAndUpdateSliderType();
        },
        { passive: true }
      );

      window.addEventListener(
        "scroll",
        () => {
          if (this.state === "auto-scroll-slider") {
            this.updateScrollSlider();
          }
        },
        { passive: true }
      );
    },

    /**
     * Check if element should be displayed as a swiper or as a auto scroll slider,
     * depending on whether the content fits inside viewport height
     */
    checkAndUpdateSliderType() {
      if (this.isHighEnoughForAutoScrollSlider() && this.state !== "auto-scroll-slider") {
        this.state = "auto-scroll-slider";
        this.runCallbackWhenHtmlIsUpdated(() => {
          this.resetSwiper();
          this.initAutoScrollSlider();
        });

        return;
      }

      if (!this.isHighEnoughForAutoScrollSlider() && this.state !== "swiper") {
        this.state = "swiper";
        this.runCallbackWhenHtmlIsUpdated(() => {
          this.resetAutoScrollSlider();
          this.initSwiper();
        });

        return;
      }
    },

    /**
     * Check if there is enough room for auto scroll slider
     */
    isHighEnoughForAutoScrollSlider() {
      const sliderHeight = this.getSliderHeight();
      const viewportHeight = this.innerHeight;
      const headerHeight = this.getHeaderHeight();
      const padding = 2 * this.autoScrollSliderPadding;

      return viewportHeight - headerHeight - sliderHeight > padding;
    },

    /**
     * AUTO SCROLL SLIDER
     */

    initAutoScrollSlider() {
      this.$refs.root.style.setProperty("height", `${this.getSliderHeight() + this.getAutoScrollSliderScrollMaxOffset()}px`);
      this.$refs.stickyContainer.style.setProperty("top", `${this.getHeaderHeight() + this.autoScrollSliderPadding}px`);
    },

    resetAutoScrollSlider() {
      this.$refs.root.style.removeProperty("height");
      this.$refs.stickyContainer.style.removeProperty("top");
    },

    updateScrollSlider() {
      const rootTop = this.$refs.root.getBoundingClientRect().top;
      const stickyContainerTop = this.$refs.stickyContainer.getBoundingClientRect().top;
      const distance = Math.abs(rootTop - stickyContainerTop);
      const progress = distance / this.getAutoScrollSliderScrollMaxOffset();
      const offset = progress * this.getAutoScrollSliderScrollMaxOffset();

      this.$refs.wrapper.style.setProperty("transform", `translateX(-${offset}px)`);
    },

    getAutoScrollSliderScrollMaxOffset() {
      const sliderLeft = this.$refs.slider.getBoundingClientRect().left;
      const wrapperWidth = this.$refs.wrapper.scrollWidth;
      const viewportWidth = innerWidth - this.scrollbarWidth;

      return wrapperWidth - viewportWidth + 2 * sliderLeft;
    },

    /**
     * SWIPER
     */

    initSwiper() {
      if (this.swiper) {
        return;
      }

      this.swiper = new Swiper(this.$refs.slider, {
        slidesPerView: "auto",
        spaceBetween: 16,
        breakpoints: {
          1024: {
            spaceBetween: 32,
          }
        }
      });
    },

    resetSwiper() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    },

    /**
     * Helpers
     */

    getHeaderHeight() {
      return document.querySelector("header.Header").getBoundingClientRect().height;
    },

    getSliderHeight() {
      return this.$refs.slider.getBoundingClientRect().height;
    },

    /**
     * Run callback when the data-state attribute is in sync with the current state value
     * AlpineJS takes some time to update the html
     * This is actually what nextTick is for, however this simply does not work
     */
    runCallbackWhenHtmlIsUpdated(callback) {
      if (this.$refs.slider.getAttribute("data-state") === this.state) {
        callback();
      }

      const interval = setInterval(() => {
        if (this.$refs.slider.getAttribute("data-state") === this.state) {
          clearInterval(interval);
          callback();
        }
      }, 5);
    },

    // https://stackoverflow.com/a/13382873
    getScrollbarWidth() {
      // Creating invisible container
      const outer = document.createElement("div");
      outer.style.visibility = "hidden";
      outer.style.overflow = "scroll"; // forcing scrollbar to appear
      outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
      document.body.appendChild(outer);

      // Creating inner element and placing it in the container
      const inner = document.createElement("div");
      outer.appendChild(inner);

      // Calculating difference between container's full width and the child width
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

      // Removing temporary elements from the DOM
      outer.parentNode.removeChild(outer);

      return scrollbarWidth;
    },
  }));
});
